<template>
  <div class="man_list">
    <div class="info_text" v-for="(item,index) in domains" v-if='index<=contentShowNum' :key="index">
      <a>{{index+1+'.'}}{{item.tips}}</a>
      <a class="pic"><img src="../../../../public/img/addProject/pic.png">{{item.imgCount}}(张)</a>
      <a class="vid"><img src="../../../../public/img/addProject/video.png">{{item.voiceCount}}(个)</a>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    props:['domains','contentShowNum'],
    mounted() {
      debugger
      this.domains.length
    }
  }
</script>

<style lang="scss" scoped>
  .info_text {
    font-size: 12px;
    color: rgba(25, 31, 37, 0.8);
    background: rgba(245, 247, 250, 1);
    border-radius: 2px;
    margin-bottom: 12px;
    height: 40px;
    width:100%;
    a:first-child{
      margin-left: 10px;
    }
    a{
      line-height: 40px;
      max-width: 510px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
     img{
        width: 12px;
        height: 12px;
        vertical-align: middle;
        margin-top: -3px;
      }
    }
    .pic{
      margin-left: 37px;
     img{ margin-right: 5px;}
    }
    .vid{
      margin-left: 23px;
      img{ margin-right: 5px;}
    }
  }

  .man_list {
    align-content: center
  }
</style>
